const createExcelType1NonsymmetricalArrayText = (
  participantNames: string[]
) => {
  let string = participantNames.toString();
  return string;
};

export default createExcelType1NonsymmetricalArrayText;
